/**
 * Which columns each kind of reader gets. A reader's job is to find and read
 * the policy in force, so their table says what it is and where it is filed
 * and nothing about its upkeep: no owner, no status, no review date.
 */
import type { LibraryWho } from './useLibrary';

export type ColumnKey = 'number' | 'title' | 'department' | 'documentType' | 'owner' | 'status' | 'review';

export interface Column { key: ColumnKey; label: string; width: string | null }

const NUMBER: Column = { key: 'number', label: 'Number', width: '128px' };
const TITLE: Column = { key: 'title', label: 'Title', width: null };
const DEPARTMENT: Column = { key: 'department', label: 'Department', width: '16%' };
/** A reader has no owner or review columns, so the department gets the room a long name needs. */
const DEPARTMENT_WIDE: Column = { key: 'department', label: 'Department', width: '24%' };
const TYPE: Column = { key: 'documentType', label: 'Document type', width: '16%' };
// Wide enough that "Waiting for somebody@hospital.org to join" takes two lines, not four.
const OWNER: Column = { key: 'owner', label: 'Owner', width: '18%' };
const STATUS: Column = { key: 'status', label: 'Status', width: '176px' };
const REVIEW: Column = { key: 'review', label: 'Next review', width: '122px' };

export function columnsFor(who: Pick<LibraryWho, 'ownersShown'>): Column[] {
  // Owners are shown to exactly the people who work on policies, and those are the people who get the upkeep columns.
  return who.ownersShown
    ? [NUMBER, TITLE, DEPARTMENT, OWNER, STATUS, REVIEW]
    : [NUMBER, TITLE, DEPARTMENT_WIDE, TYPE];
}
